import { useQuery } from "@tanstack/react-query";
import useStore from "./use-store";
import { generateSiteMeilisearchKey } from "src/api/lib/generate-site-meilisearch-key";
import { siteMeilisearchSearchKeyKeys } from "src/api/query-keys/site-meilisearch-search-key.keys";

export const useGenerateSiteSearchKey = (enabled = true) => {
  const { user } = useStore();

  return useQuery({
    queryFn: generateSiteMeilisearchKey,
    queryKey: siteMeilisearchSearchKeyKeys.detail(user?.siteToken ?? ""),
    enabled,
  });
};
